module.exports = __webpack_public_path__ + "static/media/wide.3a0049c5.jpg";